
export const TvChannelCardMobileShimmer: React.FC = () => (

    <div className="card-channel center mx-auto my-3 d-block shimmer">
        <div className="channel-item"/>
    </div>
);
